export default __webpack_public_path__ + "static/media/OrderMarker.604384d9.svg";